<template>
  <nav class="app-breadcrumbs">
    <!-- Root breadcrumb if provided -->
    <div v-if="root" class="breadcrumb-item" ref="rootRef">
      <span class="breadcrumb-text breadcrumb-first">
        <OfficeBuildingMarkerIcon :size="14" class="root-icon" />
        {{ root }}
      </span>
    </div>

    <!-- Regular breadcrumbs -->
    <div v-for="(crumb, index) in breadcrumbs" :key="index" class="breadcrumb-item">
      <span class="separator">›</span>

      <router-link v-if="crumb.link" :to="crumb.link" :class="['breadcrumb-link', { 'breadcrumb-first': !root && index === 0 }]">
        {{ crumb.label }}
      </router-link>

      <span v-else :class="['breadcrumb-text', { 'breadcrumb-first': !root && index === 0 }]">
        {{ crumb.label }}
      </span>
    </div>
  </nav>
</template>

<script>
import OfficeBuildingMarkerIcon from 'vue-material-design-icons/OfficeBuildingMarker.vue';

export default {
  name: 'AppBreadcrumbs',
  components: { OfficeBuildingMarkerIcon },
  props: {
    root: {
      type: String,
      required: false,
      default: null
    },
    breadcrumbs: {
      type: Array,
      required: true
    }
  },
  emits: ['root-click']
}
</script>

<style scoped>
.app-breadcrumbs {
  display: flex;
  align-items: center;
  gap: 4px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.separator {
  color: #999;
  font-size: 13px;
  user-select: none;
}

.breadcrumb-link {
  color: #333;
  text-decoration: none;
  font-size: 13px;
  padding: 4px 6px;
  border-radius: var(--border-radius);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.root-icon {
  opacity: 0.5;
}

.breadcrumb-link:hover {
  background-color: rgba(0, 123, 255, 0.08);
  color: var(--primary-color);
}

.breadcrumb-text {
  color: #333;
  font-size: 13px;
  padding: 4px 6px;
  border-radius: var(--border-radius);
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.breadcrumb-first {
  font-weight: 600;
  color: #000;
}

.breadcrumb-first.breadcrumb-link:hover {
  background-color: rgba(0, 123, 255, 0.08);
  color: var(--primary-color);
}
</style>